<template>
    <div class="flex center-xs">
        <div class="progress-section space-top flex" style="width:100%;">
            <h3 class="progress-percentage maison-typo">{{ progressPercentage }}%</h3>
            <span class="progress-bar-full space-left-1">
                <span class="progress-bar-progress" :style="'width: ' + progressPercentage + '%;'"></span>
            </span>
        </div>
    </div>
</template>

<script>
const PROGRESS_BAR_WIDTH = 520;

export default {
    props: ['currentStep', 'totalSteps', 'customBreakpoints', 'breakpoints'],
    computed: {
        progressFraction() {
            if(this.customBreakpoints){
                return this.breakpoints[this.currentStep]
            }
            return this.currentStep / this.totalSteps;
        },
        progressPercentage() {
            if(this.customBreakpoints){
                return this.breakpoints[this.currentStep]
            }
            return Math.round(this.progressFraction * 100);
        },
        progressWidth() {
            return Math.round(PROGRESS_BAR_WIDTH * this.progressFraction).toString();
        }
    }
}
</script>

<style lang="scss" scoped>
.progress-section {
    max-width: 588px;
}

.progress-percentage {
    font-family: Roboto;
    font-size: 24px;
    line-height: 36px;
    color: #0384FB;
}

.progress-bar-full {
    position: relative;
    width: 520px;
    height: 6px;
    margin-top: 25px;
    background: #BCBCBC;
    border-radius: 9px;
}
.progress-bar-progress {
    position: absolute;
    left: 0;
    height: 6px;
    background: #0384FB;
    border-radius: 9px;
}
</style>